export class PedigreeOptionInfo{
    title : string;
    generations : number;
}